import { LocationService } from 'src/services/location.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const LocationAction = {
    getProvinces,
    getDistrictsByProvince,
    getWardsByDistrict,
}

function getProvinces() {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            LocationService.getProvinces().then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
}

function getDistrictsByProvince(provinceCode) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            LocationService.getDistrictsByProvince(provinceCode).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
}

function getWardsByDistrict(districtCode) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            LocationService.getWardsByDistrict(districtCode).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
}